import bindings from '@digital-twins/slide-schemas/generated/slide-layouts.json'

/**
 * Every slide type's bound layout slots (plots plan Stage 2, Step 7): the layout's
 * slots with the preset's overrides applied, generated from
 * `packages/slide-schemas/layouts/` (`generate_slide_boxes.py --bindings`). The one
 * owner of slide geometry; a layout component reads its slot rects and text boxes here.
 */
export interface SlotRect {
  x: number
  y: number
  w: number
  h: number
}

export interface SlotTextBox {
  width: number
  font: string
  fontSize: number
  minFontSize: number
  lineHeight: number
  maxLines: number
  letterSpacing?: number
}

export interface BoundSlot {
  kind: string
  rect?: SlotRect
  shape?: string
  in?: string
  text?: SlotTextBox
  parts?: Record<string, SlotTextBox>
  optional?: boolean
}

type PresetBindings = Record<string, { layout: string; slots: Record<string, BoundSlot> }>

const PRESETS = (bindings as unknown as { presets: PresetBindings }).presets

/** The bound slots of one slide type; throws for a type with no preset. */
export function presetSlots(slideType: string): Record<string, BoundSlot> {
  const preset = PRESETS[slideType]
  if (!preset) throw new Error(`no layout binding for slide type ${slideType}`)
  return preset.slots
}

/** One bound slot that the preset must have (a layout's required slot). */
export function presetSlot(slideType: string, slot: string): BoundSlot {
  const bound = presetSlots(slideType)[slot]
  if (!bound) throw new Error(`${slideType} binds no ${slot} slot`)
  return bound
}
